/**
 * Fornitori che non emettono fattura (3.14, decision of 30/10/2026): an
 * insurance, a consorzio di garanzia, a Comune for a fine send a receipt, a
 * policy, a notice, never an invoice. A payment to them is the cost itself,
 * not an advance waiting for its invoice.
 */
import { z } from 'zod';
import { isoDateSchema, optionalText } from './validation.js';
/** What such a subject sends instead of an invoice. */
export const NO_INVOICE_DOCUMENTS = [
    'quietanza',
    'polizza',
    'verbale',
    'contratto',
    'nessuno',
];
export const NO_INVOICE_DOCUMENT_LABELS = {
    quietanza: 'Quietanza o ricevuta',
    polizza: 'Polizza o appendice',
    verbale: 'Verbale o avviso',
    contratto: 'Contratto',
    nessuno: 'Nessun documento',
};
/**
 * What a payment without invoice says of itself (the policy, the notice) and
 * the period it covers; ignored for a payment waiting for its invoice.
 */
export const noInvoiceFields = {
    reference: optionalText(200),
    periodFrom: isoDateSchema.nullish().transform((value) => value ?? null),
    periodTo: isoDateSchema.nullish().transform((value) => value ?? null),
};
/** The period of a payment without invoice, when both ends are given, in order. */
export function noInvoicePeriodError(from, to) {
    return from && to && from > to ? 'Il periodo finisce prima di cominciare' : null;
}
/** Body of «È senza fattura» on a payment recorded before the subject was marked. */
export const markWithoutInvoiceSchema = z.object(noInvoiceFields);
//# sourceMappingURL=no-invoice.js.map